// this constant also includes redundancy of mapping 'A': 'A' to simplify other code

const latinCharacters = {
  'A': 'A',
  'À': 'A',
  'Á': 'A',
  'Â': 'A',
  'Ã': 'A',
  'Ä': 'A',
  'Å': 'A',
  'Ā': 'A',
  'Ă': 'A',
  'Ą': 'A',
  'B': 'B',
  'C': 'C',
  'Ç': 'C',
  'Ć': 'C',
  'Ĉ': 'C',
  'Ċ': 'C',
  'Č': 'C',
  'D': 'D',
  'Ð': 'D',
  'Ď': 'D',
  'Đ': 'D',
  'E': 'E',
  'È': 'E',
  'É': 'E',
  'Ê': 'E',
  'Ë': 'E',
  'Ē': 'E',
  'Ĕ': 'E',
  'Ė': 'E',
  'Ę': 'E',
  'Ě': 'E',
  'F': 'F',
  'G': 'G',
  'Ĝ': 'G',
  'Ğ': 'G',
  'Ġ': 'G',
  'Ģ': 'G',
  'H': 'H',
  'Ĥ': 'H',
  'Ħ': 'H',
  'I': 'I',
  'Ì': 'I',
  'Í': 'I',
  'Î': 'I',
  'Ï': 'I',
  'Ĭ': 'I',
  'Ĩ': 'I',
  'Į': 'I',
  'Ī': 'I',
  'İ': 'I',
  'J': 'J',
  'Ĵ': 'J',
  'K': 'K',
  'Ķ': 'K',
  'L': 'L',
  'Ĺ': 'L',
  'Ļ': 'L',
  'Ľ': 'L',
  'Ŀ': 'L',
  'Ł': 'L',
  'M': 'M',
  'N': 'N',
  'Ñ': 'N',
  'Ń': 'N',
  'Ņ': 'N',
  'Ň': 'N',
  'Ŋ': 'N',
  'O': 'O',
  'Ò': 'O',
  'Ó': 'O',
  'Ô': 'O',
  'Õ': 'O',
  'Ö': 'O',
  'Ø': 'O',
  'Ō': 'O',
  'Ŏ': 'O',
  'Ő': 'O',
  'P': 'P',
  'Q': 'Q',
  'U': 'U',
  'Ù': 'U',
  'Ú': 'U',
  'Û': 'U',
  'Ü': 'U',
  'Y': 'Y',
  'Ý': 'Y',
  'R': 'R',
  'Ŕ': 'R',
  'Ŗ': 'R',
  'Ř': 'R',
  'S': 'S',
  'Ś': 'S',
  'Ŝ': 'S',
  'Ş': 'S',
  'Š': 'S',
  'T': 'T',
  'Ţ': 'T',
  'Ť': 'T',
  'Ŧ': 'T',
  'Ũ': 'U',
  'Ū': 'U',
  'Ŭ': 'U',
  'Ů': 'U',
  'Ű': 'U',
  'Ų': 'U',
  'V': 'V',
  'W': 'W',
  'Ŵ': 'W',
  'X': 'X',
  'Ŷ': 'Y',
  'Ÿ': 'Y',
  'Z': 'Z',
  'Ź': 'Z',
  'Ż': 'Z',
  'Ž': 'Z',
  'a': 'a',
  'à': 'a',
  'á': 'a',
  'â': 'a',
  'ã': 'a',
  'ä': 'a',
  'å': 'a',
  'æ': 'a',
  'ā': 'a',
  'ă': 'a',
  'ą': 'a',
  'b': 'b',
  'c': 'c',
  'ç': 'c',
  'ć': 'c',
  'ĉ': 'c',
  'ċ': 'c',
  'č': 'c',
  'd': 'd',
  'ď': 'd',
  'đ': 'd',
  'e': 'e',
  'è': 'e',
  'é': 'e',
  'ê': 'e',
  'ë': 'e',
  'ē': 'e',
  'ĕ': 'e',
  'ė': 'e',
  'ę': 'e',
  'ě': 'e',
  'f': 'f',
  'g': 'g',
  'ĝ': 'g',
  'ğ': 'g',
  'ġ': 'g',
  'ģ': 'g',
  'h': 'h',
  'ĥ': 'h',
  'ħ': 'h',
  'i': 'i',
  'ì': 'i',
  'í': 'i',
  'î': 'i',
  'ï': 'i',
  'ĩ': 'i',
  'ī': 'i',
  'ĭ': 'i',
  'į': 'i',
  'ı': 'i',
  'j': 'j',
  'ĵ': 'j',
  'l': 'l',
  'ĺ': 'l',
  'ļ': 'l',
  'ľ': 'l',
  'ŀ': 'l',
  'ł': 'l',
  'k': 'k',
  'ķ': 'k',
  'm': 'm',
  'n': 'n',
  'o': 'o',
  'ð': 'o',
  'ò': 'o',
  'ó': 'o',
  'ô': 'o',
  'õ': 'o',
  'ö': 'o',
  'ø': 'o',
  'ō': 'o',
  'ŏ': 'o',
  'ő': 'o',
  'p': 'p',
  'ñ': 'n',
  'ń': 'n',
  'ņ': 'n',
  'ň': 'n',
  'ŋ': 'n',
  'q': 'q',
  'r': 'r',
  'ŕ': 'r',
  'ŗ': 'r',
  'ř': 'r',
  's': 's',
  'ś': 's',
  'ŝ': 's',
  'ş': 's',
  'š': 's',
  't': 't',
  'ţ': 't',
  'ť': 't',
  'ŧ': 't',
  'u': 'u',
  'ù': 'u',
  'ú': 'u',
  'û': 'u',
  'ü': 'u',
  'ũ': 'u',
  'ū': 'u',
  'ŭ': 'u',
  'ů': 'u',
  'ű': 'u',
  'ų': 'u',
  'v': 'v',
  'w': 'w',
  'ŵ': 'w',
  'x': 'x',
  'y': 'y',
  'ý': 'y',
  'ŷ': 'y',
  'z': 'z',
  'ż': 'z',
  'ź': 'z',
  'ž': 'z',
};

export default latinCharacters;
